import { NavLink } from 'components/Share/Link'
import { useContext } from 'react'
import { useDtmAnalytics } from 'hooks/useDtmAnalytics'
import { IVehicleData } from 'types/vehicleTypes'
import { AnalyticsStore, setCustomClick } from 'utils/analyticsUtils'
import { getVdpUrl } from 'utils/urlUtils'
import { VehicleContext } from './VehicleContext'
import { StyledTitleSection, TitleVDP } from './VehicleDetails.styled'
import { VehicleRibbons } from './VehicleRibbons'
import { SessionStorageKey } from 'common/constants'
interface IProps {
  vehicleData: IVehicleData
}

export const VehicleTitleSection = ({ vehicleData }: IProps) => {
  const { isVDP, viewStyle } = useContext(VehicleContext)
  const { userInteraction } = useDtmAnalytics()
  const detailLink = getVdpUrl(vehicleData.vehicle.InstanceID)
  return (
    <StyledTitleSection className="justify-content-between">
      {isVDP ? (
        <TitleVDP onClick={() => userInteraction('vdp:ymmt')} style={{ cursor: 'pointer' }}>
          {vehicleData.vehicle.Title}
        </TitleVDP>
      ) : (
        <NavLink
          onClick={() => {
            const pageName = AnalyticsStore.pageName || 'SRP'
            setCustomClick(vehicleData.vehicle.Title, {
              usePageName: true
            })
            userInteraction(`${pageName}: VDP`, [vehicleData])
            sessionStorage.setItem(SessionStorageKey.VIEW_VEHICLE_LIST, viewStyle.toString())
          }}
          to={detailLink}
        >
          {vehicleData.vehicle.Title}
        </NavLink>
      )}
      <VehicleRibbons vehicleInfo={vehicleData.vehicle} />
    </StyledTitleSection>
  )
}
